import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/tama-coin`;

export const brandTamaCoinService = {
  subscribe,
};

// function subscribe() {
//   return fetchWrapper.get(`${baseUrl}/subscribe`);
// }

function subscribe(params) {
  return fetchWrapper.post(`${baseUrl}/subscribe`, params);}
